import { HtmlHTMLAttributes } from 'react'
import { Link } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

import { Button } from '@/components/button'
import { TitleSeparator } from '@/components/title-separator'
import { useAuth } from '@/contexts'

interface BeAGuardianProps extends HtmlHTMLAttributes<HTMLDivElement> {}
export function BeAGuardian({ className }: BeAGuardianProps) {
  const { signed } = useAuth()

  return (
    <div className={twMerge('flex flex-col gap-5', className)}>
      {!signed && <TitleSeparator title="Seja um guardião ambiental" />}
      <div className="flex flex-col items-center justify-center gap-10 xl:px-24 2xl:px-72">
        {!signed && (
          <>
            <div className="flex flex-col gap-5 md:flex-row md:gap-10 xl:max-h-52">
              <Link to="/register/preserver">
                <Button
                  asChild
                  variant="secondary"
                  size="big"
                  className="w-full py-4 xl:px-10 2xl:px-20"
                >
                  <div className="flex flex-col gap-4 text-center">
                    <h1 className="text-bios-title text-xl font-bold md:text-2xl">
                      Quero ser um conservador
                    </h1>
                    <p className="text-monochromatic-400 xl:text-base">
                      Pessoas físicas ou jurídicas com posse comprovada de
                      terras em situação regular ou projetos reconhecidos de
                      preservação e regeneração de biomas brasileiros.
                    </p>
                  </div>
                </Button>
              </Link>
              <Link to="/register/sponsor">
                <Button
                  asChild
                  variant="secondary"
                  size="big"
                  className="w-full py-4 xl:px-10 2xl:px-20"
                >
                  <div className="flex gap-3">
                    <div className="flex flex-col gap-4 text-center">
                      <h1 className="text-bios-title text-xl font-bold md:text-2xl">
                        Quero ser um patrocinador
                      </h1>
                      <p className="text-monochromatic-400 font-semibold xl:text-base">
                        Sou uma pessoa física ou jurídica que tem interesse em
                        financiar projetos de preservação e regeneração
                        ambiental.
                      </p>
                    </div>
                  </div>
                </Button>
              </Link>
            </div>
          </>
        )}

        <div className="flex flex-col gap-5">
          <h1 className="text-monochromatic-500 text-center text-lg font-bold md:text-start md:text-2xl">
            Conectamos de forma segura, transparente e auditada patrocinadores
            <p className="text-monochromatic-400 text-base font-normal md:text-center md:text-lg">
              de todas as partes do mundo com conservadores dos biomas
              brasileiros.
            </p>
          </h1>
          {!signed && (
            <Link to="/register" className="mx-auto">
              <Button className="self-start px-20 text-xs uppercase duration-300 md:text-base 2xl:px-32">
                Quero ser um guardião
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
